<app-status-pill
    [statusName]="statusName()"
    [statusColor]="statusColor()"
    [statusTooltip]="statusTooltip()"
    [size]="size()">
</app-status-pill>
